export const SIGN_IN = 'SIGN_IN';
export const SHOW_MODAL = 'SHOW_MODAL';
export const DROPDOWN_SELECTION = 'DROPDOWN_SELECTION';
export const DROPDOWN_OPEN = 'DROPDOWN_OPEN';
export const CURRENT_SLIDE = 'CURRENT_SLIDE';
export const SLIDE_SHOW = 'SLIDE_SHOW';
export const PAUSE_SLIDE_SHOW = "PAUSE_SLIDE_SHOW";
export const CREATE_SUBSCRIBER = 'CREATE_SUBSCRIBER';
export const FETCH_SUBSCRIBER = 'FETCH_SUBSCRIBER';
export const RESET_SUBSCRIBER = 'RESET_SUBSCRIBER';
export const SLIDESHOW_SPINNER_VISIBILITY = 'SLIDESHOW_SPINNER_VISIBILITY';
export const SIGNUP_SPINNER_VISIBILITY = 'SIGNUP_SPINNER_VISIBILITY';
export const NEXT_SONG = 'NEXT_SONG';
export const CURRENT_SONG = 'CURRENT_SONG';
export const ALLIMAGESLOADED = 'ALLIMAGESLOADED';
